import Head from 'next/head';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { ArrowLeft } from 'lucide-react';

const AuthLayout = ({ children, title = 'Gyan Sathi' }) => {
  const router = useRouter();

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <div className="relative min-h-screen bg-pastel-cream flex items-center justify-center px-4 py-12 overflow-hidden">
        {/* Decorative blobs to match the marketing pages */}
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute top-16 left-12 w-72 h-72 bg-pastel-rose/30 rounded-full blur-3xl" />
          <div className="absolute top-24 right-16 w-96 h-96 bg-pastel-blue/30 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-1/3 w-80 h-80 bg-pastel-lavender/30 rounded-full blur-3xl" />
        </div>

        {/* Back to home */}
        <button
          type="button"
          onClick={() => router.push('/')}
          className="absolute top-6 left-6 z-10 inline-flex items-center space-x-2 px-4 py-2 bg-white/80 backdrop-blur border-2 border-pastel-blue-dark/20 text-pastel-navy rounded-full hover:bg-white transition-all duration-300 text-sm font-semibold shadow-soft"
        >
          <ArrowLeft className="w-4 h-4" />
          <span className="hidden sm:inline">Back to Home</span>
        </button>

        <div className="relative w-full max-w-md">
          {/* Brand */}
          <Link
            href="/"
            className="flex items-center justify-center space-x-3 mb-8 select-none"
          >
            <img
              src="/assets/logo-icon.png"
              alt="Gyan Sathi Logo"
              className="h-14 w-auto"
            />
            <div className="text-left">
              <span className="block text-3xl font-bold text-pastel-navy leading-none">
                GYAN SATHI
              </span>
              <span className="block text-xs font-semibold text-pastel-navy/70 tracking-wide uppercase mt-1">
                Smart Learning Platform
              </span>
            </div>
          </Link>

          {/* Card */}
          <div className="bg-white/95 backdrop-blur rounded-3xl shadow-soft-xl border border-gray-100 p-8 sm:p-10">
            {children}
          </div>

          {/* Footer links */}
          <p className="mt-6 text-center text-xs text-gray-500">
            By continuing you agree to our{' '}
            <Link
              href="/privacy-policy"
              className="text-pastel-blue-dark font-semibold hover:underline"
            >
              Privacy Policy
            </Link>{' '}
            and{' '}
            <Link
              href="/terms-and-conditions"
              className="text-pastel-blue-dark font-semibold hover:underline"
            >
              Terms &amp; Conditions
            </Link>
            .
          </p>
        </div>
      </div>
    </>
  );
};

export default AuthLayout;
